import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { VersionService } from 'lib';

const DEFAULT_VERSION = '0.1.0';
interface IVersionMonitorProps {
  children: React.ReactNode;
}

const VersionMonitor: React.FC<IVersionMonitorProps> = ({ children }) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const version = VersionService.getVersion() || DEFAULT_VERSION;

  useEffect(() => {
    fetch(`/version.json?v=${+new Date()}`, { cache: 'no-cache' })
      .then((response) => response.json())
      .then((data) => {
        if (data?.version) {
          const latestVersion = data.version;

          if (!version || version !== latestVersion) {
            VersionService.setVersion(latestVersion);
            window.location.reload();
          } else {
            setIsLoading(false);
          }
        }
      });
  }, [location]);

  if (isLoading) return <></>;
  return <>{children}</>;
};

export default VersionMonitor;
